import React from "react";
import './header.scss';

import Title from "../../uiKit/Title/Title";

const Header = ({ title, onClick }) => {

    return (
        <div className='menu'>
            <Title
                fontSize={16}
                lineHeight={20}
                text={title.toUpperCase()}
                style={{
                    marginLeft: !!onClick ? '12px' : 0,
                    cursor: !!onClick ? 'pointer' : 'default'
                }}
                onClick={!!onClick ? onClick : () => { }}
            />
        </div>
    )
}

export default Header;